import Success from 'parog-web/components/cnam-services-access-form/process/success';
import sub_ from 'ember-math-helpers/helpers/sub';
import pluralize from 'ember-inflector/helpers/pluralize';
import gt from 'ember-truth-helpers/helpers/gt';
import { concat } from '@ember/helper';
import formatDate from 'ember-intl/helpers/format-date';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type DmpRetrievalContext from 'parog-web/contexts/dmp-retrieval-context';

const ProcessSuccess = <template>
  <Success @onDismiss={{@onDismiss}} @context={{@context}}>
    <:title>
    </:title>
    <:content>
      <div class='ui positive message'>
        <div class='content'>
          <div class='header'>Les opérations suivantes ont été effectuées :</div>
          <ul>
            {{#if @context.hasRetrievedHr}}
              <li data-test-successful-hr>L'historique de remboursement du
                patient a été bien mis à jour.</li>
            {{/if}}
            {{#if @context.hasRetrievedNonHr}}
              <li data-test-successful-documents>
                {{#let
                  (sub_
                    @context.totalDocumentsToRetrieve
                    @context.nonHrDocumentsOnError.length
                  )
                  as |totalDocuments|
                }}
                  {{pluralize totalDocuments 'document'}}
                  du DMP ont été récupérés.
                {{/let}}
              </li>
            {{/if}}
            {{#if @context.hasUpdatedNonHr}}
              <li data-test-successful-update-documents>
                {{#let
                  (sub_
                    @context.totalDocumentsToUpdate
                    @context.nonHrDocumentsUpdatesOnError.length
                  )
                  as |totalDocuments|
                }}
                  {{pluralize totalDocuments 'document'}}
                  du DMP ont été mis à jour.
                {{/let}}
              </li>
            {{/if}}
          </ul>
        </div>
      </div>
      {{#unless @context.hasRetrievedHr}}
        <div class='ui negative icon message'>
          <div class='content' data-test-unsuccessful-hr>
            Aucun historique de remboursement disponible pour ce patient.
          </div>
        </div>
      {{/unless}}
      {{#if (gt @context.nonHrDocumentsOnError.length 0)}}
        <div class='ui negative icon message'>
          <div class='content'>
            <div class='header'>
              Les documents suivants n'ont pas pu être récupérés :
            </div>
            <ul>
              {{#each @context.nonHrDocumentsOnError as |document|}}
                <li
                  data-test-unsuccessful-non-hr-document={{document.uniqueId}}
                >{{document.title}}
                  ({{if
                    document.description
                    (concat document.description ' - ')
                  }}{{formatDate document.creationTime}})</li>
              {{/each}}
            </ul>
          </div>
        </div>
      {{/if}}
      {{#if (gt @context.nonHrDocumentsUpdatesOnError.length 0)}}
        <div class='ui negative icon message'>
          <div class='content'>
            <div class='header'>
              Les documents suivants n'ont pas pu être mis à jour :
            </div>
            <ul>
              {{#each @context.nonHrDocumentsUpdatesOnError as |document|}}
                <li
                  data-test-unsuccessful-non-hr-document={{document.uniqueId}}
                >
                  {{document.title}}
                  ({{if
                    document.description
                    (concat document.description ' - ')
                  }}{{formatDate document.creationTime}})</li>
              {{/each}}
            </ul>
          </div>
        </div>
      {{/if}}
    </:content>
  </Success>
</template> satisfies TemplateOnlyComponent<{
  Args: {
    context: DmpRetrievalContext;
    onDismiss: () => void;
  };
}>;
export default ProcessSuccess;
